/* eslint-env browser */
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import SlidingPopup from 'auth0-website-sliding-popup';

let unmount = () => {};
export default function tryRender(pathname) {
  const exceptionPages = ['/signup', '/pricing'];
  if (exceptionPages.includes(pathname)) {
    unmount();
    return;
  }
  unmount = renderReactComponent(
    <SlidingPopup source="website" />,
    document.getElementById('popup')
  );
}

function renderReactComponent(instance, element) {
  let rendered = false;

  render(instance, element, setRenderedTrue);

  return unmounReactComponent;

  function setRenderedTrue() {
    rendered = true;
  }

  function unmounReactComponent() {
    if (rendered) {
      unmountComponentAtNode(element);
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/sliding-popup/client.js